import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

import "swiper/css";

const ProductSection = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  // ✅ FETCH PRODUCTS
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch("https://lappyshop.onrender.com/api/get-product");
        const result = await res.json();

        if (result.success) {
          setData(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchProducts();
  }, []);

  const safeProducts = data?.filter(p => p && p.productImage?.length);

  // ✅ ADD TO CART (WORKING)
  const addToCart = (product) => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];

    const existing = cart.find(item => item._id === product._id);

    if (existing) {
      existing.qty += 1;
    } else {
      cart.push({ ...product, qty: 1 });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    alert("Added to Cart ✅");
  };

  return (
    <div className="container mx-auto px-4 mt-10">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg md:text-2xl font-semibold text-gray-800">
          Featured Products
        </h2>

        <button
          onClick={() => navigate("/product-category")}
          className="text-blue-600 text-sm"
        >
          View All →
        </button>
      </div>

      {/* SLIDER */}
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 3000 }}
        spaceBetween={12}
        breakpoints={{
          0: { slidesPerView: 2, spaceBetween: 10 },   // 🔥 mobile 2 cards
          480: { slidesPerView: 2.2 },
          640: { slidesPerView: 2.5 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1280: { slidesPerView: 5 },
        }}
      >

        {safeProducts.map((product) => {

          const price = product?.variants?.[0]?.price || 0;
          const actual = product?.variants?.[0]?.actualPrice || price;

          const discount =
            actual > price
              ? Math.round(((actual - price) / actual) * 100)
              : 0;

          return (
            <SwiperSlide key={product._id}>

              <motion.div
                whileHover={{ y: -5 }}
                className="bg-white rounded-xl shadow-sm hover:shadow-lg transition border border-gray-100 overflow-hidden group cursor-pointer"
                onClick={() => navigate(`/product/${product._id}`)}
              >

                {/* IMAGE */}
                <div className="relative h-28 md:h-40 bg-gray-50 flex items-center justify-center overflow-hidden">

                  <img
                    src={product.productImage?.[0]}
                    alt={product.productName}
                    className="h-full object-contain transition duration-500 group-hover:scale-105"
                  />

                  {product.productImage?.[1] && (
                    <img
                      src={product.productImage?.[1]}
                      alt="hover"
                      className="absolute h-full object-contain opacity-0 group-hover:opacity-100 transition duration-500"
                    />
                  )}

                  {/* DISCOUNT BADGE */}
                  {discount > 0 && (
                    <span className="absolute top-1 left-1 bg-red-500 text-white text-[10px] px-2 py-0.5 rounded">
                      {discount}% OFF
                    </span>
                  )}

                </div>

                {/* CONTENT */}
                <div className="p-2">

                  <h3 className="text-[11px] md:text-sm font-medium text-gray-800 line-clamp-2">
                    {product.productName}
                  </h3>

                  {/* PRICE */}
                  <div className="mt-1 flex items-center gap-1">

                    <span className="text-sm md:text-lg font-bold text-black">
                      ₹{price}
                    </span>

                    {actual > price && (
                      <span className="text-[10px] text-gray-400 line-through">
                        ₹{actual}
                      </span>
                    )}

                  </div>

                  {/* BUTTONS */}
                  <div className="flex gap-1 mt-2">

                    {/* <button
                      onClick={(e) => {
                        e.stopPropagation();
                        addToCart(product);
                      }}
                      className="flex-1 bg-black text-white text-[10px] md:text-xs py-1 rounded-md hover:bg-gray-900 transition"
                    >
                      Add
                    </button> */}

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/product/${product._id}`);
                      }}
                      className="flex-1 bg-blue-600 text-white text-[12px] font-bold md:text-xs py-2 rounded-md hover:bg-blue-700 transition"
                    >
                      Quick View
                    </button>

                  </div>

                </div>

              </motion.div> 

            </SwiperSlide>
          );
        })}

      </Swiper>

    </div>
  );
};

export default ProductSection;